import { IS_MOBILE } from "const/common";
import Image from "next/image";
import { useEffect, useState } from "react";
import MarqueeHeading from "./common/MarqueeHeading";

const WireFrame = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(IS_MOBILE(600));
  }, []);
  return (
    <div className="bg-black">
      <div className="hidden md:block">
        <MarqueeHeading marqueeTitle="WIREFRAME" />
      </div>
      <h3 className="flex items-center text-white font-bold md:relative pl-6 mb-12 md:mb-0 md:ml-0 md:-mt-48 md:pl-8 xl:ml-48 xl:-mt-60 xl:pl-0">
        <Image
          alt="star"
          src="/assets/case-study/roaddy/blue-star.webp"
          width={35}
          height={35}
        />
        <span className="ml-4 text-4xl">Wireframe</span>
      </h3>
      {/* for mobile */}
      <div className="py-4 md:py-0 px-6 md:px-0">
        <h4 className="font-bold text-white text-xl md:text-4xl mb-8 md:mb-0 md:pt-40 md:pb-16 md:ml-8 xl:ml-0 xl:pt-40 xl:pb-16 xl:pl-48">
          <span className="font-gilroy">Low-Fidelity Wireframes</span>
        </h4>
        {isMobile ? (
          <div className="flex flex-col">
            <div className="flex justify-center">
              <Image
                alt="Low-fidelity wireframes showing a rough hand drawn screens of roadside service app"
                className="mb-4"
                loading="lazy"
                src="/assets/case-study/roaddy/lfw-1.webp"
                width={340}
                height={400}
              />
            </div>
            <div className="flex justify-center">
              <Image
                alt="Low-fidelity wireframes showing a rough hand drawn screens of roadside service app"
                className="mb-4"
                loading="lazy"
                src="/assets/case-study/roaddy/lfw-2.webp"
                width={340}
                height={400}
              />
            </div>
          </div>
        ) : (
          <div className="fs-0">
            <Image
              alt="Low-fidelity wireframes showing a rough hand drawn screens of roadside service app"
              loading="lazy"
              src="/assets/case-study/roaddy/low-fidelity.webp"
              width={1920}
              height={681}
            />
          </div>
        )}
      </div>
      <div className="py-4 md:py-0 px-6 md:px-0">
        <h4 className="font-bold text-white text-xl md:text-4xl mb-8 md:mb-0 md:pt-40 md:pb-16 md:ml-8 xl:ml-0 xl:pt-40 xl:pb-16 xl:pl-48">
          <span className="font-gilroy">High-Fidelity Wireframes</span>
        </h4>
        {isMobile ? (
          <div className="w-full flex justify-center">
            <Image
              alt="High-Fidelity Wireframe showing different app screens of roadside service app"
              loading="lazy"
              src={"/assets/case-study/roaddy/hfw-mob.webp"}
              width={340}
              height={2922}
            />
          </div>
        ) : (
          <div className="w-full">
            <Image
              alt="High-Fidelity Wireframe showing different app screens of roadside service app"
              loading="lazy"
              src={"/assets/case-study/roaddy/high-fidelity.webp"}
              width={1920}
              height={1400}
            />
          </div>
        )}
      </div>
      <div className="flex justify-center bg-[url(/assets/case-study/roaddy/bottom-curve.webp)] bg-no-repeat bg-contain bg-center">
        <div className="xl:w-full flex justify-center">
          <Image
            alt="Final roadside service app on iPhone 14 Plus"
            loading="lazy"
            src="/assets/case-study/roaddy/trimob.webp"
            width={1422}
            height={896}
          />
        </div>
      </div>
    </div>
  );
};
export default WireFrame;
